import { List, Create, CreateSubMenu, Edit, SubMenuList } from "../Components/index.js";

export default [
    {
        path: "/admin/setting/menu",
        component: List,
        name: "setting.menu",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/menu/create",
        component: Create,
        name: "setting.menu.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/menu/:id/edit",
        component: Edit,
        name: "setting.menu.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/menu/:id/sub",
        component: SubMenuList,
        name: "setting.sub.menu",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/menu/:id/sub/create",
        component: CreateSubMenu,
        name: "setting.submenu.create",
        meta: {
            requiresAuth: true,
        },
    },
];
